import Vue from 'vue';
import Router from 'vue-router';
import store from "@/store";
import IframeCommunicatorService, { InterPagesMessages, MessageTypes } from "@/services/IframeCommunicatorService";
import { eraseCookie, getCookie, setCookie } from './utils/HelperFunctions';
import GlobalConfig from "@/GlobalConfig";
import Swal from "sweetalert2";
import { FLAG_UNRESTRICTED } from 'html2canvas/dist/types/css/syntax/tokenizer';
import AfiliadoService from './services/AfiliadoService';

var afiliadoService = new AfiliadoService();
var iframeService = new IframeCommunicatorService();
Vue.use(Router);

var router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            meta: {
                requireAuth: true
            },
            component: () => import('./views/DashBoard.vue')
        },
        {
            path: '/logout',
            meta: {
                requireAuth: true
            },
            component: () => {
				store.dispatch("logOut");
				window.location.href = GlobalConfig.PORTAL_BASE_URL;
			}
        },
        {
            path: '/home',
            name: 'home',
            meta: {
                requireAuth: true
            },
            component: () => import('./views/DashBoard.vue')
        },
        {
            path: '/solicitudes-beneficiario',
            name: 'solicitudes-beneficiario',
            meta: {
                requireAuth: false,
            },
            //component: () => import('./views/SolicitudesBeneficiario.vue')
            component: () => import('./views/Home.vue')
        },
        {
            path: '/consulta-afiliado-fallecido',
            name: 'consulta-afiliado-fallecido',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/ConsultaAfiliadoFallecido.vue')
        },
        {
            path: '/registro-beneficiario',
            name: 'registro-beneficiario',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/RegistroBeneficiario.vue')
        },
        {
            path: '/registro-fallecimiento',
            name: 'registro-fallecimiento',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/RegistroFallecimiento.vue')
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/Login.vue')
        },
        {
            path: '/perfil',
            name: 'perfil',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/Perfil.vue')
        },
        {
            path: '/recuperacion-contrasena',
            name: 'recuperacion-contrasena',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/RecuperacionContrasena.vue')
        },
        {
            path: '/cambio-contrasena',
            name: 'cambio-contrasena',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/CambioContrasena.vue')
        },
        {
            path: '/devolucion-ingreso-tardio',
            name: 'devolucion-ingreso-tardio',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/DevolucionIngresoTardio.vue')
        },
        {
            path: '/registro-ingreso-tardio',
            name: 'registro-ingreso-tardio',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/RegistroIngresoTardio.vue')
        },
        {
            path: '/resumen-solicitud-it',
            name: 'resumen-solicitud-it',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/ResumenIT.vue')
        },
        {
            path: '/actualizacion-datos',
            name: 'actualizacion-datos',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/ActualizacionDatos.vue')
        },
        {
            path: '/encuesta',
            meta: {
                requireAuth: true
            },
            component: () => import('./views/Encuesta.vue')
        },
        {
            path: '/close',
            meta: {
                requireAuth: false
            },
            component: () => import('./views/CloseWindow.vue')
        },
        {
            path: '/cesantia',
            name: 'cesantia',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/Cesantia.vue')
        },
        {
            path: '/registro-cesantia',
            name: 'registro-cesantia',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/RegistroCesantia.vue')
        },
        {
            path: '/resumen-solicitud-cesantia',
            name: 'resumen-solicitud-cesantia',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/ResumenCesantia.vue')
        },
        {
            path: '/resumen-redireccionador',
            name: 'resumen-redireccionador',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/ResumenRedireccionador.vue')
        },
        {
            path: '/registro-vejez-anticipada',
            name: 'registro-vejez-anticipada',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/RegistroVejezAnticipada.vue')
        },
        {
            path: '/vejez-anticipada',
            name: 'vejez-anticipada',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/VejezAnticipada.vue')
        },
        {
            path: '/resumen-solicitud-vejez-anticipada',
            name: 'resumen-solicitud-vejez-anticipada',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/ResumenVejezAnticipada.vue')
        },
        {
            path: '/consulta-reclamaciones',
            name: 'consulta-reclamaciones',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/consulta-reclamaciones/ConsultaReclamaciones.vue')
        },
        {
            path: '/actualizacion-de-datos',
            name: 'actualizacion-de-datos',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/actualizacion-datos/ActualizacionDatos.vue')
        },
        {
            path: '/result-actualizacion-datos',
            name: 'result-actualizacion-datos',
            meta: {
                requireAuth: true,
            },
            component: () => import("@/views/actualizacion-datos/ResultActualizacionDatos.vue")
        },
        {
            path: '/consulta-tu-cuenta',
            name: 'consulta-tu-cuenta',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/consulta-tu-cuenta/ConsultaTuCuenta.vue')
        },
        {
            path: '/mi-inversion',
            name: 'mi-inversion',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/mi-inversion/MiInversion.vue')
        },
        {
            path: '/notificacion-aportes',
            name: 'notificacion-aportes',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/notificacion-aportes/NotificacionAportes.vue')
        },
        {
            path: '/notificacion-balance',
            name: 'notificacion-balance',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/notificacion-balance/NotificacionBalance.vue')
        },
        {
            path: '/solicitud-reclamaciones',
            name: 'solicitud-reclamaciones',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/solicitud-reclamaciones/SolicitudReclamaciones.vue')
        },
        {
            path: '/tipo-envio-estado-cuenta',
            name: 'tipo-envio-estado-cuenta',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/tipo-envio-estado-cuenta/TipoEnvioEstadoCuenta.vue')
        },
        {
            path: '/tu-estado-cuenta',
            name: 'tu-estado-cuenta',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/new-tu-estado-cuenta/NewTuEstadoCuenta.vue')
            //component: () => import('./views/DashBoard.vue')
        },
        {
            path: '/certificado-beneficios',
            name: 'certificado-beneficios',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/certificado-beneficios/CertificadoBeneficios.vue')
        },
        {
            path: '/NewLogin',
            name: "New-login",
            meta:{
                requireAuth: false
            },
            component: () => import("./views/NewLogin.vue")
        },
        {
            path: '/DashBoard',
            name: "Dash-Board",
            meta:{
                requireAuth: true
            },
            component: () => import("./views/DashBoard.vue")
        },
        {
            path: '/TourVirtual',
            name: "Tour-Virtual",
            meta:{
                requireAuth: true
            },
            component: () => import("./views/TourVirtual.vue")
        },
        {
            path: '/registro-sobrevivencia',
            name: 'registro-sobrevivencia',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/registro-sobrevivencia/RegistroSobrevivencia.vue')
        },
        {
            path: '/resumen-sobrevivencia',
            name: 'resumen-sobrevivencia',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/registro-sobrevivencia/ResumenSobrevivencia.vue')
        }, 

        {
            path: '/new-tu-estado-cuenta',
            name: 'new-tu-estado-cuenta',
            meta: {
                requireAuth: true,
            },
            component: () => import('./views/new-tu-estado-cuenta/NewTuEstadoCuenta.vue')
            //component: () => import('./views/DashBoard.vue')
        },
        
        {
            path: '/cambio-password',
            name: 'cambio-password',
            meta: {
                requireAuth: false,
            },
            component: () => import('./views/cambio-password/CambioPassword.vue')
            //component: () => import('./views/DashBoard.vue')
        },
    ]
});

router.beforeEach((to, from, next) => {
    Swal.close();
    document.body.classList.add("loading");
    var exp = getCookie("portalBe_exp")
    if (exp) {
        //If has value
        var expDate = new Date(exp);
        var past = expDate.getTime();
        var twenyMin = 1000 * 60 * 20;
        var isPast = (new Date(new Date().toUTCString()).getTime() - past < twenyMin) ? false : true;
        if (isPast) {
            store.dispatch("logOut");
        } else {
            setCookie("portalBe_exp", new Date().toUTCString());
            // Ping to Portal Siembra To Refresh session
            iframeService.postMessageToParent(new InterPagesMessages(MessageTypes.Ping, ""))
        }
    }

   if (to.path == "/registro-sobrevivencia"){
        if(!to.query["params"] && !store.getters.isLoggedIn){
            next({
                path: '/login',
                query: {
                    redirectPage: to.fullPath.includes("sessionId") ? to.path : to.fullPath,
					sessionId: to.query.sessionId as string
                }
            })
        }
         
    }

    // If it is login, redirect to B2C
    if (to.path == "/login") {
        var redirectoTo = to.query["redirectPage"] || from.fullPath;
        var isFromAfpLogin = to.query["fromLogin"];
        var redirectToSiembra = to.query["redirectToSiembra"];
        if (store.getters.isLoggedIn) {
            if (redirectToSiembra || isFromAfpLogin) {
                to.query.invalidUser = "true"
                next();
                return;
            }

            if (redirectoTo) {
                next(redirectoTo as string);
            }
            else {
                next("/solicitudes-beneficiario");
            }
        } else {
            next();
        }
    }
	else if(to.path == "/logout"){
		let sessionId = to.query["sessionId"]
		afiliadoService.logOut(sessionId as string);
		next();
	}
	else if(from.path != '/solicitudes-beneficiario' && to.path == "/home" && store.getters.isLoggedIn){
		next({path: '/DashBoard'});
	}
	else {
        // if it is root page, and user is not logged in, redirect to home
        if (to.path == "/" && !store.getters.isLoggedIn) {
            next({
                path: '/home',
            });
        }
        else if (to.meta.requireAuth && !store.getters.isLoggedIn) {
            next({
                path: '/login',
                query: {
                    redirectPage: to.fullPath.includes("sessionId") ? to.path : to.fullPath,
					sessionId: to.query.sessionId as string
                }
            });
        } else {
            next();
        }
    }
});

router.afterEach((to, from) => {
    document.body.classList.remove("loading");

    let toPath = to.fullPath;
    let encoded = btoa(toPath);
    iframeService.postMessageToParent(new InterPagesMessages(MessageTypes.RouteChange, encoded));
});

 
export default router;

